import ServiceConditionChoice from './ServiceConditionChoice';

export default class ServiceCondition {
  constructor(obj) {
    this.widget = obj.widget;
    this.group_name = obj.group_name;
    this.choices = obj.choices.map(choice => new ServiceConditionChoice(choice));
  }
}
